import { Col, Form, Input, Radio, Space } from "antd";
import { useState } from "react";

const rules = {
  required: [{ required: true, message: "Campo obrigatório!" }],
  requiredNoMessage: [{ required: true, message: "" }],
};

const ObjectiveQuestion = ({ loading, obrigatorio, questao, id, alternativas, defaultValue = null }) => {
  const [value, setValue] = useState(defaultValue);

  return (
    <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
      <Form.Item
        name={["objective", `${id}`]}
        initialValue={defaultValue}
        label={<strong>{questao}</strong>}
        rules={obrigatorio === 1 ? rules.required : null}>
        <Radio.Group disabled={loading} onChange={(value) => setValue(value.target.value)}>
          <Space direction="vertical">
            {alternativas?.map((alternativa) => {
              return (
                <Radio key={alternativa.id} value={alternativa.id}>
                  {alternativa.alternativa}

                  {value === alternativa.id && alternativa.exige_complemento === 1 && (
                    <Form.Item
                      initialValue={alternativa.complemento ?? ""}
                      name={["complement", `${alternativa.id}`]}
                      rules={rules.requiredNoMessage}
                      noStyle>
                      <Input size="large" disabled={loading} placeholder={"Complemento"} />
                    </Form.Item>
                  )}
                </Radio>
              );
            })}
          </Space>
        </Radio.Group>
      </Form.Item>
    </Col>
  );
};

export { ObjectiveQuestion };
